export default __webpack_public_path__ + "static/media/MISTRZ_MOCY.5f7a98a6.png";